export default __webpack_public_path__ + "static/media/ic_arrow_left.9d0610a4.svg";